module.exports = __webpack_public_path__ + "img/pyq.7426a11f.png";